import React, { useEffect, useMemo } from 'react';

import { useSnackbar } from 'notistack';

import {
    useCreatorLevel,
    useSnapshotActionsToTrigger,
} from '../../../../selectors/index.hooks';
import { useTask } from '../../../../selectors/composed/index.hooks';

import { ISourceSetEntity } from '../../../../../../state/types';
import {
    resetRestorer,
    setActionsToTrigger,
} from '../../../../../../state/ui/discovery/snapshotting';
import { useTaskFetching } from '../../../../../../state/app/fetching/selectors/index.hooks';

import {
    filterByDate,
    filterById,
} from '../../../../../../helpers/filterObject';
import TranslationHelper from '../../../../../../helpers/TranslationHelper';
import { useAppDispatch } from '../../../../../../hooks';

import ShowEventButton from '../../../ShowEventButton';
import IconWithWarning from '../../../../../../components/IconWithWarning';

export const DiscoveryTaskShowEventButton = () => {
    const dispatch = useAppDispatch();
    const { enqueueSnackbar } = useSnackbar();

    const task = useTask();
    const actionsToTrigger = useSnapshotActionsToTrigger();

    const creatorLevel = useCreatorLevel();

    const taskFetchingStatus = useTaskFetching().status;

    const showEventTriggerAction = actionsToTrigger?.some(
        (action) => action.type === 'showEvent'
    );

    const metaHeaderTask = task?._meta.header.task;

    const showEventButton = task?._meta.menu?.find(
        (item) => item.id === 'showEvent'
    );
    const hasStatusDate = !!metaHeaderTask?.statusDate;

    const getTaskStatusDate = useMemo(() => {
        return metaHeaderTask?.statusDate || '';
    }, [task]);

    useEffect(() => {
        if (
            !showEventTriggerAction ||
            taskFetchingStatus === 'idle' ||
            taskFetchingStatus === 'loading'
        ) {
            return;
        }
        if (!task) {
            ejectTriggerAction('Event not found');
        } else if (task && !hasStatusDate) {
            ejectTriggerAction('Selected task does not have related event');
        } else if (task && !showEventButton) {
            ejectTriggerAction('Related event cannot be displayed');
        }
    }, [showEventTriggerAction, task, taskFetchingStatus]);

    const ejectTriggerAction = (text: string) => {
        dispatch(setActionsToTrigger(undefined, creatorLevel));
        dispatch(resetRestorer());
        enqueueSnackbar(TranslationHelper.translate(text), {
            variant: 'error',
        });
    };

    const getEventId = (entities: ISourceSetEntity[]) => {
        if (!task) {
            return null;
        }
        return (
            filterById(entities, task?.id, 'TASKID')?.id ??
            filterByDate(entities, getTaskStatusDate, 'updatedAt')?.id
        );
    };
    return (
        <>
            {showEventButton &&
                (hasStatusDate ? (
                    <ShowEventButton
                        getEventId={getEventId}
                        showEventButton={showEventButton}
                        triggerOnRender={showEventTriggerAction}
                    />
                ) : (
                    <IconWithWarning title="Task has no status date, so event won't be selected">
                        <ShowEventButton
                            getEventId={getEventId}
                            showEventButton={showEventButton}
                            triggerOnRender={showEventTriggerAction}
                        />
                    </IconWithWarning>
                ))}
        </>
    );
};
